import {
  API_GET_CSI_ALERT,
  API_GET_SERVERS,
  API_GET_SERVER_INFO,
  API_SET_NEW_INSTANCE,
} from "../ApiConstants";
import axios from "../client/rest";
import jwt_decode from "jwt-decode";

class ServerInfoApi {
  static sharedInstance = new ServerInfoApi();

  constructor() {
    if (ServerInfoApi.sharedInstance !== null) {
      return ServerInfoApi.sharedInstance;
    }
  }

  isTokenValid() {
    const jwtObj = jwt_decode(localStorage.getItem("token") ?? "") as any;
    const currentTime = new Date();
    const expireTime = new Date(jwtObj.exp * 1000);

    if (expireTime < currentTime) {
      localStorage.clear();
      window.location.reload();
    }
  }

  async getServersByGroup(body: any) {
    try {
      const res = await axios.post(API_GET_SERVERS, body);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async setNewInstance(body: any) {
    try {
      const res = await axios.post(API_SET_NEW_INSTANCE, body);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getServerInfoData() {
    try {
      const res = await axios.get(API_GET_SERVER_INFO);
      const { data } = res;
      if (res.status === 200) {
        return data.data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (error) {
      throw error;
    }
  }

  async getCsiAlerts() {
    try {
      this.isTokenValid();
      const res = await axios.get(API_GET_CSI_ALERT);
      const { data } = res;
      if (res.status === 200) {
        return data;
      } else {
        throw res || "Something went wrong";
      }
    } catch (error) {
      throw error;
    }
  }
}

export default ServerInfoApi.sharedInstance;
